import React, { Component } from 'react';
import ReactPlayer from 'react-player';
import { Trans } from '@lingui/macro';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { contrastTextColor, shadeColor, ensureURLProtocol } from '../utils';
import { networks } from '../consts';
import Icons from '../components/Icons';
import styles from './BragifyEmbedItem.module.css';
import Caption from '../components/Caption';

function testImage(/* item, onError */) {
  /* const url = item?.media[0]?.medium;
  const tester = new Image();
  tester.onerror = err => onError(item, err);
  tester.src = url; */
}

class PostFront extends Component {
  constructor(props) {
    super(props);
    this.setPostRef = (element) => {
      this.postRef = element;
    };

    this.state = {
      currentSlide: 0,
    };
  }

  componentDidMount() {
    const { item, onMediaError } = this.props;
    this.setState({ currentSlide: 0 });
    if (item?.media[0]?.medium) {
      testImage(item, onMediaError);
    }

    if (this.playerRef?.base?.firstChild?.play) {
      setTimeout(() => {
        // eslint-disable-next-line
        this.playerRef?.base?.firstChild?.play?.();
      }, 2000);
    }
  }

  componentDidUpdate() {
    const { item } = this.props;
    const { currentSlide } = this.state;

    if ((item.media || []).length > 1) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if ((item.media || []).length - 1 > currentSlide) {
          this.setState({ currentSlide: currentSlide + 1 });
        } else {
          this.setState({ currentSlide: 0 });
        }
      }, Math.random() * 5000 + 10000);
    }
  }

  handleVideoError = (err) => {
    const { onMediaError, item } = this.props;
    onMediaError(item, err);
  };

  setPlayerRef = (element) => {
    this.playerRef = element;
  };

  render() {
    const { item, options, formatDistanceLocale } = this.props;
    const { currentSlide } = this.state;
    const { customLink = {} } = item;
    const captionLength = customLink.linkUrl ? 150 : 320;

    return (
      <div ref={this.setPostRef} className={styles['post-front']}>
        {item.media[0] &&
          item.media.map((m, i) => {
            if (!m) return null;
            const classes =
              currentSlide === i
                ? `${styles['post-slide']} ${styles['post-slide--active']}`
                : `${styles['post-slide']}`;

            if (m.video) {
              return (
                <div key={m.medium} className={classes}>
                  <div className={styles['post-front-bg']}>
                    <ReactPlayer
                      url={m.video}
                      volume={0}
                      muted
                      playing
                      loop
                      playsinline
                      width="100%"
                      height="100%"
                      className={styles['post-front-video']}
                      ref={this.setPlayerRef}
                      onError={this.handleVideoError}
                    />
                  </div>
                  {options.gridHideCaptions && (
                    <div className={styles['post-front-info']}>
                      <div>
                        <div>@{item.username}</div>
                        <div>
                          {formatDistanceLocale(new Date(item.time), new Date())} <Trans>ago</Trans>
                        </div>
                      </div>
                      <div>
                        <div key="social-icon" className={styles['social-icon']}>
                          <Icons
                            icon={item.service}
                            color={contrastTextColor(options.secondaryColor)}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            }
            return (
              <div key={m.medium} className={classes}>
                <div className={styles['post-front-bg']}>
                  <picture>
                    <source srcSet={m.thumbnail} media="(max-width: 800px)" />
                    <img alt={item.altText} src={m.medium} loading="lazy" />
                  </picture>
                  {item.service === networks.TIK_TOK && (
                    <FontAwesomeIcon icon={faPlay} className={styles['post-front-icon']} />
                  )}
                </div>
                {options.gridHideCaptions && (
                  <div className={styles['post-front-info']}>
                    <div>
                      <div>@{item.username}</div>
                      <div>
                        {formatDistanceLocale(new Date(item.time), new Date())} <Trans>ago</Trans>
                      </div>
                    </div>
                    <div>
                      <div key="social-icon" className={styles['social-icon']}>
                        <Icons
                          icon={item.service}
                          color={contrastTextColor(options.secondaryColor)}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        {!item.media[0] && (
          <div
            key="post-text"
            className={styles['post-text']}
            style={{
              background: shadeColor(options.secondaryColor),
              color: contrastTextColor(options.secondaryColor),
            }}
          >
            {!options.disableDates && item.service !== networks.CUSTOM && (
              <div className={styles.ts}>
                {formatDistanceLocale(new Date(item.time), new Date())} <Trans>ago</Trans>
              </div>
            )}
            <div className={styles.caption}>
              <Caption
                service={item.service}
                color={options.primaryColor}
                maxLength={captionLength}
                disableLinks={options.disableHashtagLinks}
              >
                {item.caption}
              </Caption>
            </div>
            {customLink.linkText && customLink.linkUrl && (
              <div className={styles['button-link__container']}>
                <a
                  target="blank"
                  tabIndex="-1"
                  className={styles['button-link']}
                  onClick={this.handleLinkClick}
                  href={ensureURLProtocol(customLink.linkUrl)}
                  style={{
                    color: contrastTextColor(options.secondaryColor),
                    borderColor: contrastTextColor(options.secondaryColor),
                    textAlign: 'center',
                  }}
                >
                  {item.customLink.linkText}
                </a>
              </div>
            )}
            {item.service !== networks.CUSTOM ? (
              <div className={styles.footer}>
                <div className={styles['user-info']}>
                  <div className={styles['profile-image']}>
                    <img src={item.profilePic} />
                  </div>
                  <div className={styles['usernames-container']}>
                    <div className={styles.username}>{item.fullname}</div>
                    <div className={styles['user-handle']}>@{item.username}</div>
                  </div>
                </div>
                <div key="social-icon" className={styles['social-icon']}>
                  <Icons icon={item.service} color={contrastTextColor(options.secondaryColor)} />
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
        )}
      </div>
    );
  }
}
export default PostFront;
